import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'

const PolicyReady = () => {
  const [redirect, setRedirect] = useState(false)
  
  useEffect(() => {
    document.cookie = 'Cookies=;expires=Thu, 01 Jan 1970 00:00:00 UTC;'
    setRedirect(true)
  }, [])

  return redirect ? <Navigate to="/unauthenticated" state={{ policyReady: true }} /> : null
}

export default PolicyReady